module.exports = __webpack_public_path__ + "img/2.ce40edb2.png";